/**
 * Keeps a case's Monitor live while the case is open (PRD-0075 R-B6): mounted once in the case
 * layout, it follows the case's stream so the bell and the inbox update without a reload, on
 * whichever page of the case the reader is. Renders nothing.
 */
import { useMonitorLiveUpdates } from './useMonitorInbox'

export function MonitorLiveUpdates({ caseId }: { caseId: string }) {
  useMonitorLiveUpdates(caseId)
  return null
}
